import { useCallback } from "react";
import { useToken, useUser } from "@packsize/authentication";
import { useFeatureFlags } from "@packsize/feature-flags";

import { getSiteToken } from "@/api/identity-api";
import { companyUrl } from "@/environment";

import { UserMenuTemplate } from "./user-menu.template";

export const UserMenu = () => {
	const { hasAnyRole, currentUser } = useUser();
	const { isFeatureFlagEnabled } = useFeatureFlags();
	const { decodedToken } = useToken();

	const showCompanyManagement =
		hasAnyRole(["TenantAdmin", "ManageCompanyAccess", "AccountManager", "PacksizePartner"]) == true &&
		isFeatureFlagEnabled("vaporware-company-link") === true;

	const handleCompanyManagementClick = useCallback(async () => {
		if (decodedToken === null || decodedToken === undefined) {
			return;
		}

		const tenantId = decodedToken.tid;
		const tokenResponse = await getSiteToken(tenantId);
		const encodedToken = btoa(tokenResponse.access_token);

		window.open(
			`${companyUrl}/sites?token=${encodeURIComponent(encodedToken)}&tenantId=${encodeURIComponent(tenantId)}`,
			"_blank",
		);
	}, [decodedToken]);

	return (
		<UserMenuTemplate
			currentUser={currentUser}
			showCompanyManagement={showCompanyManagement}
			onCompanyManagementClick={handleCompanyManagementClick}
		/>
	);
};
